<template>
  <v-container id="provider">
    <v-row>
      <h1 class="mt-12 mb-12  font-weight-light">
        Contact Us
      </h1>
      
    </v-row>
    </v-container>
</template>

<script>
export default {};
</script>

<style scoped></style>
